<template>
    <div>
        <h1>{{ $t('labels.select_packaging') }}</h1>

        <div class="actions actions--fixed" v-if="packagings && packagings.length">
            <div class="action" v-for="packaging in packagings" :key="packaging.id">
                <a
                    href="#"
                    :class="getButtonClasses(packaging)"
                    @click.prevent="registerPackaging(packaging)"
                >
                    <figure class="action-figure">
                        <img :id="'packaging-' + packaging.id" :src="getImage(packaging)" height="75" width="75" v-if="packaging.image_path" />
                    </figure>
                    <span>{{ getName(packaging) }}</span>
                </a>
            </div>
        </div>

        <div class="actions actions--fixed" v-else>
            <div class="action" v-text="$t('labels.no_packagings_yet')"></div>
        </div>

        <div class="app-actions">
            <cancel-button :redirect="cancelRedirect()"></cancel-button>
        </div>
    </div>
</template>

<script>
import CancelButton from "../components/app/CancelButton";
import {writeTrackLog} from "../utils/tracking";
import {isOnline} from "@/utils/online";
import FileCache from "@/utils/file";

export default {
  name: 'select-packaging',
  components: {CancelButton},
  computed: {
    currentDevice() {
      return this.$store.getters.currentDevice
    },

    currentActivity() {
      return this.$store.getters.currentActivityForEmployee
    },

    packagings() {
      return this.$store.getters.packagings
    }
  },

  methods: {
    getButtonClasses(packaging) {
      return {
        'action-button': true,
        'action-button--withFigure': true,
        'active': this.currentActivity && this.currentActivity.packaging && packaging && this.currentActivity.packaging === packaging.id
      };
    },

    registerPackaging(packaging) {
      console.log('registerPackaging', this.currentActivity)
      this.$store.dispatch('updateActivity', {
        ...this.currentActivity,
        packaging: packaging.id
      });

      if (this.$store.state.enableTracking) writeTrackLog("Register packaging: " + JSON.stringify({
        activity: this.currentActivity.id,
        packaging: packaging.id
      }));

      if (this.$parent.preRegistering) {

        return this.$store.commit('setChecked');
      }

      const route = this.$parent.determineRoute(this.currentActivity);

      if (route !== null && route !== undefined) this.$router.push(route)
    },

    getImage(packaging) {
      if (isOnline()) {
        if (packaging.image_path !== null && packaging.image_path !== undefined) return packaging.image_path;
      } else if (packaging.image_path !== null)  {
        let parts = packaging.image_path.split('/');
        let fileName = parts[parts.length-1];
        FileCache.get(fileName, (fileEntry) => {
          document.getElementById('packaging-' + packaging.id).src = fileEntry.toURL();
          return fileEntry.fullPath;
        })
      }
    },

    getName(packaging) {
      if (!packaging) return this.$t('labels.no_packagings_yet');

      const lang = document.documentElement.lang;

      if (packaging.translations && packaging.translations[lang]) return packaging.translations[lang];

      return packaging.name
    },

    cancelRedirect() {
      if (this.currentActivity) {
        const activity = this.$store.getters.activityById(this.currentActivity.activity_id);

        if (activity.register_team_numbers) return {name: 'team'};
      }

      return {name: 'activity'};
    }
  },

  mounted() {
    window.events.$emit('disableNumpad');
    if (this.$store.state.enableTracking) writeTrackLog("VIEW: Select packaging");

    if ((this.$store.getters.currentEmployee === null || this.$store.getters.currentEmployee === undefined) && this.currentDevice.register_activities && this.currentActivity) {
      this.$router.push({name: 'pin'})
    }
  }
}
</script>
